import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=2d75087a"
import script from "./Beneficios.vue?vue&type=script&lang=js"
export * from "./Beneficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports